import { URL } from '../constants';
import { apiLoaderInstance } from '../instance';

export const hospitalList = () =>
  apiLoaderInstance.get(URL.GET_BITWERX_HOSPITAL_LIST);
